import React, { useEffect } from 'react'
import { View, Dimensions } from 'react-native'
import useKeyPress from '../../hooks/useKeyPress'
import mainButton from '../../../assets/arena/throttle_button.png'


const { height, width } = Dimensions.get('screen');
const KEY_THROTTLE_BY_PLAYER_INDEX = {
  0: 'z',
  1: 'm',
}
const SCREEN_POS_BY_PLAYER_INDEX = {
  // player 1 lower right
  0: {
    posX: width - 100,
    posY: height - 100,
    width,
    height,
  },
  // player 2 lower left
  1: {
    posX: 0,
    posY: height - 100,
    width: 100,
    height,
    color: '#00f',
  }
}
const COLORS_BY_PLAYER_INDEX = {
  0: {
    player: '#AFC97E',
    controller: '#AFC97E',
  },
  1: {
    player: '#306BAC',
    controller: '#306BAC',
  }
}
const usePlayers = (refs = []) => {
  const playersConfig = refs.map((p, idx) => {
    return (
      {
        name: `player${idx + 1}`,
        ...SCREEN_POS_BY_PLAYER_INDEX[idx],
        keyboardThrottle: KEY_THROTTLE_BY_PLAYER_INDEX[idx],
        isThrottling: false,
        hit: false,
        controller: p,
        color: COLORS_BY_PLAYER_INDEX[idx],
      }
    )
  })
  
  return playersConfig
}

const useHitArea = (hitAreaPlayers = []) => {
  const checkTouchOnPlayerAreas = evt => {
    hitAreaPlayers.forEach(ha => ha.hit = false)
    if(evt.nativeEvent.touches && evt.nativeEvent.touches[0] || evt.nativeEvent.type === 'mousedown') {
      hitAreaPlayers[1].hit = true
      const touchTime = Date.now()
      hitAreaPlayers[1].lastTouchTime = touchTime
    }
    // evt.nativeEvent.touches.forEach(t => {
    //   hitAreaPlayers.forEach(ha => {
    //     if (
    //       (t.pageX > ha.posX &&
    //       t.pageY > ha.posY &&
    //       t.pageX < ha.posX + ha.width &&
    //       t.pageY < ha.posY + ha.height)
    //       || ha.isThrottling
    //     ) {
    //       // const touchTime = global.nativePerformanceNow()
    //       const touchTime = window.performance.now()
    //       const diff = touchTime - ha.lastTouchTime;
    //       if (diff < 150) {
    //         ha.doubleTap = true
    //       } else {
    //         ha.doubleTap = false
    //       }
    //       ha.hit = true
    //       ha.lastTouchTime = touchTime;
    //     }
    //   })
    // })

    hitAreaPlayers.forEach(ha => {
      if (ha.hit) {
      }
      ha.controller.dispatch(`controller_${ha.hit ? 'on' : 'off'}`)
      if (ha.doubleTap) {
        ha.doubleTap = false
        // ha.controller.dispatch('controller_doubleTap')
      }
    })
  }
  return {
    handleTouchStart: checkTouchOnPlayerAreas,
    handleTouchEnd: checkTouchOnPlayerAreas,
  }
}

const Controllers = ({ forPlayers = [], noUI}) => {
  // gets players config
  const players = usePlayers(forPlayers)

  useEffect(() => {
    // setTimeout(() => {
    //   players.find(p => p.name === 'player1').controller.dispatch('controller_restart')
    // }, 5000);
    // external API
    window.SS_controller_p2_throttle = state => {
      players[1].isThrottling = state
      handleTouchStart({ nativeEvent: { touches: state ? [{}] : undefined }})
    }
    // window.SS_controller_p1_throttle = state => {
    //   players[0].isThrottling = state
    //   handleTouchStart({ nativeEvent: { touches: [{}] }})
    // }
  }, [])
  
  // makes player configs to handle events
  const { handleTouchStart, handleTouchEnd } = useHitArea(players)
  // (players[0].keyboardThrottle)
  const P1ThrottleKeyPressed = useKeyPress(players[0].keyboardThrottle)
  useEffect(() => {
    players[0].isThrottling = P1ThrottleKeyPressed
    handleTouchStart({ nativeEvent: { touches: P1ThrottleKeyPressed ? [{}] : undefined }})
  }, [P1ThrottleKeyPressed])

  const P2ThrottleKeyPressed = useKeyPress(players[1].keyboardThrottle)
  useEffect(() => {
    players[1].isThrottling = P2ThrottleKeyPressed
    handleTouchStart({ nativeEvent: { touches: P2ThrottleKeyPressed ? [{}] : undefined }})
  }, [P2ThrottleKeyPressed])

  useEffect(() => {
    window.oncontextmenu = function(event) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    };
  }, []);
  return (
    <React.Fragment>
      {
        players[0] && !noUI ? 
        <View
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleTouchStart}
        onMouseUp={handleTouchEnd}
        style={{ position: 'absolute', zIndex: 100, width: 100, height: 100, bottom: 30, right: 50,
        // backgroundColor: `${players[0].color.controller}aa`
      }}
      >
          <img src={mainButton}
          style={{ position: 'relative', width: 100, height: 100}} />
        </View>:null
      }
      {/* {
        players[1] && !noUI?
        <View
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
            style={{ position: 'absolute', width: 100, height: 100, bottom: 0, left: 0, backgroundColor: `${players[1].color.controller}aa`
           }}
        >
          <img src={mainButton} />
        </View>:null
      } */}
    </React.Fragment>
  )
}

export default Controllers